let POPUP_ID = 1

export const genPopupId = () => `${POPUP_ID++}`
